import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import { ToastContainer, toast, Slide } from 'react-toastify';
import ModalTrigger from '../common/ModalTrigger';
import { postRequest } from '../../requestUtils';
import './AdminCreateInvoiceModal.scss';

class AdminCreateInvoiceModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      startDate: new Date(),
    };

    this.handleCreateInvoice = this.handleCreateInvoice.bind(this);
  }

  handleCreateInvoice() {
    const { projectId, createInvoiceUrl, csrfToken } = this.props;
    const { startDate } = this.state;

    const params = { invoice: { project_id: projectId, start_date: startDate } };

    postRequest(createInvoiceUrl, params, csrfToken)
      .then(
        () => window.location.reload(),
        (error) => toast.error(error.message),
      );
  }

  render() {
    const { triggerText, triggerType } = this.props;
    const { startDate } = this.state;

    return (
      <ModalTrigger
        triggerText={triggerText}
        buttonStyles="primary"
        submitButtonText="Create Timesheet"
        cancelButtonText="Cancel"
        handleSubmit={this.handleCreateInvoice}
        triggerType={triggerType}
        idKey="admin-create-invoice"
        modalSize="md"
      >
        <ToastContainer
          position="top-center"
          transition={Slide}
          hideProgressBar
          autoClose={4000}
          closeOnClick
          draggable={false}
          pauseOnHover
        />
        <div className="admin-create-invoice-modal-content mx-4">
          <div className="admin-create-invoice-text mb-5">
            Creating a timesheet for a month that
            already has an existing timesheet is not allowed, but otherwise
            there are no limitations on what month you can select.
            <p />
            Select the month for which you want to create a timesheet in the box below.
          </div>
          <div className="admin-create-invoice-datepicker">
            <DatePicker
              selected={startDate}
              onChange={(newDate) => this.setState({ startDate: newDate })}
              dateFormat="MM/yyyy"
              showMonthYearPicker
              showFullMonthYearPicker
              showTwoColumnMonthYearPicker
            />
          </div>
        </div>
      </ModalTrigger>
    );
  }
}

export default AdminCreateInvoiceModal;

AdminCreateInvoiceModal.propTypes = {
  projectId: PropTypes.number.isRequired,
  createInvoiceUrl: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  triggerText: PropTypes.string.isRequired,
  triggerType: PropTypes.string.isRequired,
};
